/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import CommentSvg from 'images/v5/icons/annotation.svg';
import DotsSvg from 'images/v5/icons/dots-vertical.svg';
import EditSvg from 'images/v5/icons/edit-02.svg';
import LayerTwoIcon from 'images/v5/icons/layers-two-01.svg';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import { openModal } from 'store/layoutSlice';
import { removeProjectionPoint } from 'store/specificationProjectionsSlice';
import env from 'utils/env';
import Button from '../Button/Button';
import Dropdown from '../Dropdown/Dropdown';
import styles from './Note.module.scss';
function Note({ id, author, note, picture, type, component, disabled, style, onMouseDown, onClick, }) {
    const { t } = useTranslation(['common']);
    const dispatch = useDispatch();
    const handleEditPoint = () => {
        dispatch(openModal({ name: 'commentEditor', data: { id, note, picture, type, component } }));
    };
    const handleDeletePoint = () => {
        dispatch(removeProjectionPoint({ projectionPointId: id }));
    };
    return (React.createElement("article", { className: styles.wrap, "data-draggable": true, style: style, onMouseDown: onMouseDown, onClick: onClick },
        React.createElement("header", { className: styles.header },
            React.createElement("h2", { className: styles.author },
                React.createElement(CommentSvg, null),
                author),
            !disabled && (React.createElement(Dropdown, { trigger: React.createElement(Button, { size: "xs", shape: "rounded", theme: "ghost" },
                    React.createElement(DotsSvg, null)) },
                React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(EditSvg, null), onClick: handleEditPoint }, t('edit')),
                React.createElement(Button, { align: "left", theme: "ghost", color: "danger", leftIcon: React.createElement(TrashSvg, null), onClick: handleDeletePoint }, t('delete'))))),
        picture && (React.createElement("div", { className: styles.cover },
            React.createElement("img", { src: `${env.static}/${picture}`, alt: note }))),
        note && React.createElement("p", { className: styles.note }, note),
        component && (React.createElement("p", { className: styles.component },
            React.createElement(LayerTwoIcon, null),
            " ", component === null || component === void 0 ? void 0 :
            component.name)),
        React.createElement("main", null)));
}
export default Note;
